<template>
    <el-form
        ref="registerForm"
        :model="form"
        :rules="rules"
        @keyup.enter.native="onSubmit"
    >
        <p class="orangetext">
            Fill in your new password in the two fields below to change it.
        </p>
        <el-row :gutter="20">
            <el-col :sm="24" :md="12">
                <el-form-item prop="password" class="form-group" :error="$t(formErrors.get('password'))"
                              :rules="[{
                               required: true, message: 'Password is required', trigger: 'blur'
                          },
                          {min: 8, message: 'Password should be at least 8 characters', trigger: 'blur'}
                        ]">
                    <el-input
                        v-model="form.password"
                        :placeholder="$t('auth.register.password_label')+'*'"
                        name="password"
                        show-password
                    />
                </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12">
                <el-form-item prop="password_confirmation" class="form-group"
                              :rules="[
                            {required: true, message: 'Password Confirmation is required', trigger: 'blur'},
                            {validator: validatePassConfirmation, trigger:'blur'}
                        ]">
                    <el-input
                        :placeholder="$t('auth.register.password_confirmation_label')+'*'"
                        v-model="form.password_confirmation"
                        name="password_confirmation"
                        show-password
                    />
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :sm="24" :md="12">
                &nbsp;
            </el-col>
            <el-col :sm="24" :md="12" class="text-right">
                <el-button
                    :loading="loading"
                    @click.prevent="onSubmit"
                >
                    Change Password
                </el-button>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>
import {Errors} from '../../../includes/Errors'
import InputWh from '@/core/components/InputWithHint'

export default {
    name: 'RegisterForm',
    props: {
        errors: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    components: {
        InputWh
    },
    data() {
        return {
            form: {
                email: this.$route.query.email,
                token: this.$route.query.token,
                password: '',
                password_confirmation: ''
            },
            rules: {
                email: [
                    {required: true, message: 'Email is required', trigger: 'blur'},
                    {min: 3, max: 255, message: 'Length should be 3 to 255', trigger: 'blur'},
                    {type: 'email', message: 'Please input correct email address', trigger: 'blur'}
                ]
            },
            formErrors: new Errors()
        }
    },
    watch: {
        errors: function (val) {
            this.formErrors.record(this.errors)
        }
    },
    mounted: function () {
        let user = this.$auth.user();
        if (user) {
            this.form = JSON.parse(JSON.stringify(user));
        }
    },
    methods: {
        checkPrivacy(rule, value, callback) {
            if (!value) {
                callback(new Error('You must agree to the privacy policy'));
            } else {
                callback();
            }
        },
        validatePassConfirmation(rule, value, callback) {
            if (value && value !== this.form.password) {
                callback(new Error('Password and password confirmation must match'));
            } else {
                callback();
            }
        },
        onSubmit(e) {
            this.validateForm('registerForm').then((valid) => {
                this.$emit('submit', this.form)
            })
        },
        async validateForm(formName) {
            if (typeof this.formErrors !== 'undefined') {
                this.formErrors.clear(null)
            }
            return this.$refs[formName].validate()
        }
    }
}
</script>

<style lang="scss">

</style>
